export default "__VITE_ASSET__42mj1Cbo__"